import { render, staticRenderFns } from "./SettingsExpirationDate.vue?vue&type=template&id=777165c2"
import script from "./SettingsExpirationDate.vue?vue&type=script&lang=js"
export * from "./SettingsExpirationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports